import { TextField } from '@mui/material';
import ReactInputMask from 'react-input-mask';

interface Props {
  label: string;
  value: string;
  name: string;
  className?: string;
  error?: any;
  hasError?: boolean;
  handleBlur?: (e: any) => void;
  handleChange?: (e: any) => void;
  disabled?: boolean;
}

export const InputPhone = ({
  label,
  value,
  name,
  className,
  error,
  hasError,
  handleBlur,
  handleChange,
  disabled,
}: Props) => {
  return (
    <ReactInputMask
      disabled={disabled}
      mask='(99) 99999-9999'
      value={value}
      maskChar=' '
      handleBlur={handleBlur}
      onChange={handleChange}
    >
      {/*// @ts-expect-error - .*/}
      {() => (
        <TextField
          size='small'
          disabled={disabled}
          name={name}
          InputLabelProps={{ shrink: true }}
          label={label}
          className={className}
          error={hasError}
          helperText={error}
        />
      )}
    </ReactInputMask>
  );
};
